import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getDependentBuyer } from '../../services/buyer'

export const GET_DEPENDENT_BUYER = 'GET_DEPENDENT_BUYER'
export const GET_DEPENDENT_BUYER_ERROR = 'GET_DEPENDENT_BUYER_ERROR'
export const GET_DEPENDENT_BUYER_SUCCESS = 'GET_DEPENDENT_BUYER_SUCCESS'
export const onGetDependentBuyer = makeActionCreator(GET_DEPENDENT_BUYER)
export const onGetDependentBuyerError = makeActionCreator(GET_DEPENDENT_BUYER_ERROR, 'payload')
export const onGetDependentBuyerSuccess = makeActionCreator(GET_DEPENDENT_BUYER_SUCCESS, 'payload')
export const onGetDependentBuyerThunk = payload => async dispatch => {
  dispatch(onGetDependentBuyer())

  try {
    const { data } = await getDependentBuyer({ actionType: GET_DEPENDENT_BUYER, dni: payload.dni })

    const buyersList = data?.payload?.organismosDependientes.length > 0 ? data?.payload?.organismosDependientes : []
    const organismList = buyersList.map(buyer => {
      return {
        dni: buyer?.rut,
        orgLegalName: buyer?.razonSocial
      }
    })

    return dispatch(
      onGetDependentBuyerSuccess({
        buyer: organismList
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetDependentBuyerError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
